<template>
  <div>
    <el-row class="Box">
      <div class="" style="float: left;">
        <i class="el-icon-s-home home" @click="jumpTo('main')"></i>
      </div>
      <el-col class='box-li'>
        <li class="section5_item section5_item1 animate__animated animate__fadeInDown"
          swiper-animate-effect="fadeInDown" swiper-animate-delay="0.6s" swiper-animate-style-cache=" "
          style="visibility: visible;list-style: none; animation-delay:0.6s;">
          <span class="s1"></span>
          <div class="img img1" @click="clickDialog('sq')"><img src="@/assets/img/section5_01.png" width="100%"
              height="100%" alt=""></div>
          <h2>01.</h2>
          <i></i>
          <p>水情预警<br>regimen</p>
        </li>

      </el-col>
      <el-col class='box-li'>
        <li class="section5_item section5_item2 animate__animated animate__fadeInDown"
          swiper-animate-effect="fadeInDown" swiper-animate-delay="0.9s" swiper-animate-style-cache=" "
          style="visibility: visible;list-style: none; animation-delay:0.9s;">
          <span class="s2"></span>
          <div class="img img2" @click="clickDialog('yq')"><img src="@/assets/img/section5_02.png" width="100%"
              height="100%" alt=""></div>
          <h2>02.</h2>
          <i></i>
          <p>雨情预警<br>rain condition</p>
        </li>
      </el-col>
      <el-col class='box-li'>
        <li class="section5_item section5_item3 animate__animated animate__fadeInDown"
          swiper-animate-effect="fadeInDown" swiper-animate-delay="1.2s" swiper-animate-style-cache=" "
          style="visibility: visible;list-style: none; animation-delay:1.2s;">
          <span class="s3"></span>
          <div class="img img2" @click="clickDialog('sz')"><img src="@/assets/img/section5_03.png" width="100%"
              height="100%" alt=""></div>
          <h2>03.</h2>
          <i></i>
          <p>水质预警<br>quality</p>
        </li>
      </el-col>
      <el-col class='box-li'>
        <li class="section5_item section5_item4 animate__animated animate__fadeInDown"
          swiper-animate-effect="fadeInDown" swiper-animate-delay="1.5s" swiper-animate-style-cache=" "
          style="visibility: visible;list-style: none; animation-delay:1.5s;">
          <span class="s4"></span>
          <div class="img img2" @click="clickDialog('hd')"><img src="@/assets/img/section5_04.png" width="100%"
              height="100%" alt=""></div>
          <h2>04.</h2>
          <i></i>
          <p>河道预警<br>river course</p>
        </li>
      </el-col>
      <div class="skaqText animate__fadeInUp animate__animated" swiper-animate-effect="fadeInRight"
          swiper-animate-delay="0.8s" swiper-animate-style-cache=" "
          style="visibility: visible;animation-delay:1.8s;-webkit-animation-delay1.8s;">
          <h1 style="color: #fff;font-size: 20px;line-height: 40px;">水库安全</h1>
        <p class=" " >
          <span>水库对防汛减灾、供水保障和农业灌溉等至关重要。党的十九届五中全会提出要加快病险水库除险加固，国务院常务会议明确“十四五”期间水库除险加固和运行管护要消除存量隐患，实现常态化管理。该系统可帮助水利局和水库管理部门全面掌握大坝的变形、渗流、环境量等情况，实时监测水库水雨情，视频监控现场实况，实现水库防汛和大坝安全监测和预警，
          为水库安全鉴定、水库除险加固方案制定和防汛指挥调度提供数据依据，同时满足水库管理现代化的需要。</span>
        </p>
      </div>
      <el-dialog :title=title :visible.sync="dialogVisible" width="60%" class="dialogStyle">
        <el-image :src=imgSrc alt="" />

      </el-dialog>
    </el-row>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        imgSrc: '',
        title: '',

      }
    },
    methods: {
      jumpTo(param) {
        this.$emit('mainData', param)
        console.log(param)
      },
      clickDialog(e) {
        this.dialogVisible = true
        if (e == "sq") {
          this.imgSrc = require('@/assets/img/sq1.png')
          this.title = '水情监测'
        } else if (e == 'yq') {
          this.imgSrc = require('@/assets/img/yq.png')
          this.title = '雨情监测'
        } else if (e == 'sz') {
          this.imgSrc = require('@/assets/img/sz.png')
          this.title = '水质监测'
        } else if (e == 'hd') {
          this.imgSrc = require('@/assets/img/hd.png')
          this.title = '河道预警'
        }
      }

    }
  }
</script>
<style>
  .el-dialog {
    background: rgba(37, 40, 67, 0.9) !important;
    color: #fff;
  }

  .el-dialog .el-dialog__title {
    color: #fff;
  }

  .el-dialog .el-dialog__body {
    color: #fff;
  }
</style>

<style scoped>
  .Box {
    width: 100%;
    height: calc(100vh - 120px);
    padding: 5px;
    border: 1px solid #fff;
    position: relative;
    overflow: hidden;
   
  }

  .box-li {
    width: 300px;
    margin-left: 100px;
    color: #fff;
  }

  .Box .box-li:nth-child(1) {
    height: 400px;
    /* border-right: 1px solid #fff; */
  }

  .s1 {
    display: block;
    width: 50%;
    height: 300px;
    border-right: 1px solid #fff;
    ;
  }

  .section5_item .img1 {
    width: 200px;
    height: 220px;
    margin-left: 50px;
    margin-top: 10px;
    cursor: pointer;
  }

  .Box .box-li:nth-child(2) {
    height: 500px;
    /* border-right: 1px solid #fff; */
  }

  .s2 {
    display: block;
    width: 50%;
    height: 440px;
    border-right: 1px solid #fff;
    ;
  }

  .section5_item .img2 {
    width: 160px;
    height: 180px;
    margin-left: 70px;
    margin-top: 10px;
    cursor: pointer;
  }

  .Box .box-li:nth-child(3) {
    height: 350px;
    /* border-right: 1px solid #fff; */
  }

  .s3 {
    display: block;
    width: 50%;
    height: 320px;
    border-right: 1px solid #fff;
    ;
  }

  .section5_item .img3 {
    width: 100px;
    height: 120px;
    margin-left: 90px;
    margin-top: 10px;
    cursor: pointer;
  }

  .Box .box-li:nth-child(4) {
    height: 350px;
    /* border-right: 1px solid #fff; */
  }

  .s4 {
    display: block;
    width: 50%;
    height: 160px;
    border-right: 1px solid #fff;
    ;
  }

  .section5_item .img4 {
    width: 140px;
    height: 160px;
    margin-left: 90px;
    margin-top: 10px;
    cursor: pointer;
  }

  .dialogStyle img {
    width: 100%;
    height: 800px;

  }

  .home {
    display: inline-block;
    width: 50px;
    height: 50px;
    line-height: 50px;
    vertical-align: middle;
    font-size: 20px;
    cursor: pointer;
    color: #fff;
    /* text-align: left; */

  }
  .skaqText{
    position: absolute;
    bottom: 100px;
    right: 100px;
    padding: 10px;
    background-color: rgba(34, 60, 101, 1.0);
    border-radius: 5px;
  }
  .skaqText p{
    width: 400px;
    color: #fff;
    text-indent: 20px;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/skaq/index.vue